import {
    ApplicationRef,
    createComponent,
    EmbeddedViewRef,
    Inject,
    Injectable,
    RendererFactory2,
} from '@angular/core';

import {DOCUMENT} from '@angular/common';
import {IModalParamsV3} from '../interfaces/i-modal-params-v3';
import {IModalDialogV3} from '../interfaces/i-modal-dialog-v3';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ModalDynamicV3Service {

    public openDialogs: IModalDialogV3[] = [];

    private readonly OPENED_MODAL_CLASS = 'scrolling-disabled';

    constructor(
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private document: Document,
        private appRef: ApplicationRef,
    ) {
        // Add global keydown listener for Escape key
        this.document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {

                // // Check for mat-select and mat-datepicker specific states
                // const isMatOverlayPaneOpen = !!this.document.querySelector('.cdk-overlay-pane');
                // const isAppRevertDialogOpen = !!this.document.querySelector('app-g-revert-dialog');
                //
                // // Ignore Escape if mat-select or mat-datepicker is open
                // if (isMatOverlayPaneOpen || isAppRevertDialogOpen) {
                //     console.log('Escape key pressed, but mat-select, mat-datepicker or app-g-revert-dialog is open. Ignoring.');
                //     return;
                // }

                if (this.openDialogs.length > 0) {
                    const lastDialog = this.openDialogs[this.openDialogs.length - 1];
                    if (lastDialog) {
                        lastDialog.globalEscapeKeyEvent.emit(event);
                    }
                }
            }
        });
    }

    // open(component: any , params?: IModalParams): Observable<any> {
    open(component: any, params?: IModalParamsV3, skipScrollbarHiding = false): IModalDialogV3 {
        // 1. Create a component reference from the component
        // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = createComponent(component, {
            environmentInjector: this.appRef.injector,
        });

        // there is possible to bind data
        (componentRef.instance as IModalDialogV3).modalParams = params;
        (componentRef.instance as IModalDialogV3).myComponentRef = componentRef;
        (componentRef.instance as IModalDialogV3).modalDynamicV3Service = this;

        // 2. Attach component to the appRef so that it's inside the ng component tree .... so form pristine and so on will works
        this.appRef.attachView(componentRef.hostView);

        // 3. Get DOM element from component
        const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

        // 4. Append DOM element to the body element
        const renderer = this.rendererFactory.createRenderer(null, null);
        renderer.appendChild(this.document.body, domElem);

        if (!skipScrollbarHiding) {
            document.body.classList.add(this.OPENED_MODAL_CLASS);
        }

        this.openDialogs.push(componentRef.instance as IModalDialogV3);

        // return (componentRef.instance as IModalDialog).modelChanged.asObservable();
        return componentRef.instance as IModalDialogV3;

        // 5. Wait some time and remove it from the component tree and from the DOM - this is the way how the dialog will be closed
        // setTimeout(() => {
        //     this.appRef.detachView(componentRef.hostView);
        //     componentRef.destroy();
        // }, 3000);
    }

    openAsPromise(component: any, params?: IModalParamsV3, returnWithComponentRef: boolean = false): Promise<any> {
        return new Promise((resolve, reject) => {
            const modalDialog = this.open(component, params);
            const subscription = (modalDialog.modelChanged as Observable<any>).subscribe({
                next: (result) => {
                    if (returnWithComponentRef) {
                        resolve({result, componentRef: modalDialog});
                    } else {
                        resolve(result);
                    }
                    subscription.unsubscribe();
                },
                error: (err) => {
                    reject(err);
                    subscription.unsubscribe();
                }
            });
        });
    }

    public close(dialog: IModalDialogV3): void {

        this.appRef.detachView(dialog.myComponentRef.hostView);
        this.appRef.tick(); // without this, the next destroy() command sometimes reload the page
        dialog.myComponentRef.globalEscapeKeyEventSub?.unsubscribe();
        dialog.myComponentRef.destroy();

        dialog.isClosed = true;

        this.openDialogs = this.openDialogs.filter(d => !d.isClosed);
        if (this.openDialogs.length === 0) {
            document.body.classList.remove(this.OPENED_MODAL_CLASS);
        }

        // Trigger change detection manually
    }


    public closeAllDialogs(): void {
        this.openDialogs.forEach(dialog => {
            try {
                dialog?.myComponentRef?.destroy();
            } catch (e) {
                console.error('Error while destroying dialog', e);
            }

        });
        this.openDialogs = [];
        document.body.classList.remove(this.OPENED_MODAL_CLASS);
    }

    public isAnyDialogOpened(): boolean {
        return this.openDialogs.length > 0;
    }
}
